import { Component } from "../components/index"
import { qsa, qs } from "../utils/index"
import gsap from "gsap"

export default class SingleReview extends Component {
  constructor(obj) {
    super(obj)
    this.widgetSlides = qsa(".jdgm-rev", this.el)
    this.smooth = obj.renderer.smooth || false
    this.review = qs(".singleReview-text", this.el)
    this.author = qs(".singleReview-author", this.el)
  }

  setup() {
    if (this.widgetSlides.length === 0) {
      gsap.set(this.el, { display: "none" })
      requestAnimationFrame(() => {
        this.smooth?.update()
      })
      return
    }

    this.widgetSlides.forEach((slide, index) => {
      const stars = qsa(".jdgm--on", slide)
      const title = qs(".jdgm-rev__title", slide)
      const review = qs(".jdgm-rev__body", slide)
      const name = qs(".jdgm-rev__author", slide)

      if (index === 0) {
        this.review.innerText = review?.innerText
        this.author.innerText = name?.innerText

        requestAnimationFrame(() => {
          this.smooth?.update()
        })
      }
    })
  }
}
